const baseUrl = "/api/centralization"

const CentralizationEntity = (backClient) => ({
  index: async () => await backClient.get(baseUrl),
})

export default CentralizationEntity
